/**
 * Google Analytics 4 helpers — consent-aware.
 * GA only loads if the user accepted cookies.
 */

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

const STORAGE_KEY = "qualita-cookie-consent";
// GA4 Measurement ID — public value, safe to commit.
const GA_ID = "G-5GS494GNFK";

let loaded = false;

export const hasCookieConsent = (): boolean => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return false;
    const parsed = JSON.parse(stored);
    return parsed?.value === "accepted";
  } catch {
    return false;
  }
};

export const loadGoogleAnalytics = () => {
  if (loaded || !GA_ID || typeof window === "undefined") return;
  if (!hasCookieConsent()) return;

  // Inject gtag.js
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, {
    anonymize_ip: true,
    send_page_view: true,
  });

  loaded = true;
};

export const trackEvent = (
  name: string,
  params?: Record<string, unknown>
) => {
  if (typeof window === "undefined" || !window.gtag || !hasCookieConsent()) return;
  window.gtag("event", name, params || {});
};

export const trackPageView = (path: string) => {
  if (typeof window === "undefined" || !window.gtag || !hasCookieConsent() || !GA_ID) return;
  window.gtag("config", GA_ID, { page_path: path });
};
